import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import store from './store'
import Maintenance from '@/components/project/Maintenance.vue'
import DeleteApplication from './views/Home/DeleteApplication.vue'
import ApplicationGeneralData from './views/Home/Application/ApplicationGeneralData.vue'
import ApplicationCallbacks from './views/Home/Application/ApplicationCallbacks.vue'
import ApplicationPermissions from './views/Home/Application/ApplicationPermissions.vue'
import ApplicationDescriptions from './views/Home/Application/ApplicationDescriptions.vue'
import ApplicationAdditionalData from './views/Home/Application/ApplicationAdditionalData.vue'
import ApplicationSecurity from './views/Home/Application/ApplicationSecurity.vue'
import ApplicationKeys from './views/Home/Application/ApplicationKeys.vue'
import ApplicationImages from './views/Home/Application/ApplicationImages.vue'
import ApplicationReview from './views/Home/Application/ApplicationReview.vue'

const CreateApplication = () => import(/* webpackChunkName: "create" */ './views/Home/CreateApplication.vue')
const Application = () => import(/* webpackChunkName: "application" */ './views/Home/Application.vue')

Vue.use(VueRouter)
const router = new VueRouter({
  linkActiveClass: '_active',
  linkExactActiveClass: '_active',
  mode: 'history',
  routes: [
    {
      path: '/application',
      name: 'home',
      component: Home,
      beforeEnter (to, from, next) {
        if (store.getters.maintenance) next({ name: 'maintenance' })
        else next()
      },
      children: [
        {
          path: '/application/:publicAppKey/delete',
          component: DeleteApplication,
          name: 'delete-application'
        }
      ]
    },
    {
      path: '/application/create',
      name: 'createApplication',
      component: CreateApplication,
      beforeEnter (to, from, next) {
        if (store.getters.maintenance) {
          next({ name: 'maintenance' })
        }
        next()
      }
    },
    {
      path: '/application/:publicAppKey/edit',
      component: Application,
      children: [
        {
          path: '',
          name: 'application',
          redirect: '/application/:publicAppKey/edit/keys'
        },
        {
          path: 'keys',
          name: 'application-keys',
          component: ApplicationKeys
        },
        {
          path: 'generalDatas',
          name: 'application-generalDatas',
          component: ApplicationGeneralData
        },
        {
          path: 'descriptions',
          name: 'application-descriptions',
          component: ApplicationDescriptions
        },
        {
          path: 'images',
          name: 'application-images',
          component: ApplicationImages
        },
        {
          path: 'callbacks',
          name: 'application-callbacks',
          component: ApplicationCallbacks
        },
        {
          path: 'permissions',
          name: 'application-permissions',
          component: ApplicationPermissions
        },
        {
          path: 'additionalData',
          name: 'application-additionalData',
          component: ApplicationAdditionalData
        },
        {
          path: 'security',
          name: 'application-security',
          component: ApplicationSecurity
        },
        {
          path: 'review',
          name: 'application-review',
          component: ApplicationReview
        }
      ],
      beforeEnter (to, from, next) {
        if (store.getters.maintenance) {
          next({ name: 'maintenance' })
        }
        next()
      }
    },
    {
      path: '/application/maintenance',
      name: 'maintenance',
      component: Maintenance,
      beforeEnter: (to, from, next) => {
        if (store.getters.maintenance) {
          next()
        } else {
          next({ name: 'default' })
        }
      }
    },
    {
      path: '',
      redirect: '/application'
    },
    {
      path: '*',
      redirect: '/application'
    }
  ]
})

router.beforeEach((_to, _from, next) => {
  const needsToFillProfile = store.state.user.profile.isLoading
  if (needsToFillProfile) {
    store.dispatch('SET_PROFILE').then(() => next())
  } else {
    next()
  }
})

export default router
